import PropTypes from 'prop-types';

const preSelectionsType = PropTypes.shape({
  page: PropTypes.number,
  search: PropTypes.string,
  showMobileFiltersFullScreen: PropTypes.bool,
  sort: PropTypes.string,
});

export default preSelectionsType;
